import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const updatePageIndex = createAction(types.UPDATE.PAGE_INDEX);
export const updateShouldCallInit = createAction(types.UPDATE.SHOULD_CALL_INIT);
